<template>
  <div :class="menuIsOpen ? 'left-menu-card' : 'left-menu-card hidden-menu'">

    <div class="menu-switch" @click="checkMenuToggle">
      <span :class="menuIsOpen ? 'open-btn hidden' : 'open-btn show'"></span>
      <span :class="menuIsOpen ? 'close-btn open-btn show' : 'close-btn open-btn hidden'"></span>
    </div>

    <div class="upper-wrapper">
      <div v-show="login" class="factory-name">
        <img v-if="factory_logo && factory_logo.length != 0" class="title-logo" :src="factory_logo" alt="なし">
        <img v-else class="title-logo" src="../assets/images/factory_default.png" alt="なし">
        <p class="title-text">{{ name }}</p>
      </div>
      <p class="title-text">ID {{ projectId }}</p>
      <p class="title-text">見積金額</p>
      <p v-show="login" class="total-price">{{ formatPrice(totalPrice) }}</p>
      <p v-show="!login" class="total-price">¥---</p>
    </div>

    <div v-show="login" class='detail'>
      <a v-show='!isDetail' class='toggle' @click='toggleDetail'>
        <span>詳細を表示</span><i class="img" v-html='svg.arrowDown'></i>
      </a>
      <a v-show='isDetail' class='toggle' @click='toggleDetail'>
        <span>詳細を非表示</span><i class="img" v-html='svg.arrowUp'></i>
      </a>
      <ul v-show='isDetail' class='cost-items'>
        <li v-for="item in detailPrices" :key="item.name">
          <span class='name'>{{ item.name }}<br/>{{ item.subName }}</span>
          <span>{{ formatPrice(item.price) }}</span>
        </li>
        <li>
          <span style='margin-right: 10px;'>※</span>
          <span>上記に加え、別途送料・梱包費が発生します。依頼後にそれらを含めた正式なお見積りをご連絡致します。</span>
        </li>
      </ul>
    </div>

    <div class="button-group">
      <a v-show="login" class="button border-button" @click.prevent.stop="$emit('setPrice')">
        <img src='@/assets/images/ui/gear_white.png' /><span>価格の設定</span>
      </a>
      <a v-show="login" class="button green-button" @click.prevent.stop="$emit('calculate')">
        <img src='@/assets/images/ui/download.png' /><span>見積書・請求書</span>
      </a>
      <a v-if="!login" class="button border-button login-button" @click.prevent.stop="$emit('requireLogin')">
        <img src='@/assets/images/ui/gear_white.png' /><span>ログインして表示</span>
      </a>
      <a v-else-if="login" class="button gray-button" @click.prevent.stop="$emit('logout')">
        <span>ログアウト</span>
      </a>
    </div>
  </div>
</template>

<script>

import { formatPrice, formatTime } from '@/assets/javascripts/Formatter';

import svgArrowDown from '@/assets/images/plugin/arrow_down.svg';
import svgArrowUp from '@/assets/images/plugin/arrow_up.svg';

export default  {
  name: "LeftMenuCard",
  props: {
    login: Boolean,
    name: '',
    projectId: Number,
    totalPrice: 0,
    priceProfile: {},
    detailPrices: Array,
    factory_logo: '',
  },

  data () {
    return {
      isDetail: false,
      svg: {
        arrowUp: svgArrowUp,
        arrowDown: svgArrowDown,
      },
      menuIsOpen: true,
    }
  },

  methods: {
    formatPrice (price) {
      if (price === undefined) return 0;
      if (typeof price != 'number') return price;
      return formatPrice(price);
    },

    formatTime (time) {
      if (time === undefined) return 0;
      return formatTime(time);
    },
    toggleDetail () {
      this.isDetail = !this.isDetail;
    },
    checkMenuToggle () {
      if (this.menuIsOpen) {
        this.menuIsOpen = false;
      } else {
        this.menuIsOpen = true;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .left-menu-card {
    position: absolute;
    z-index: 99;
    left: 0;
    top: 50%;
    transform: translateX(0px) translateY(-50%);
    width: 300px;
    color: #fff;
    background-color: #000;
    padding: 2rem 1rem;

    transition: all .5s ease-out;

    .menu-switch {
      position: absolute;
      width: 30px;
      height: 60px;
      background-color: #000;
      z-index: 999;
      right: -30px;
      top: 50%;
      transform: translateY(-50%);

      // display: none;
      display: flex;
      align-items: center;
      justify-content: center;

      cursor: pointer;

      // @media only screen and (max-width: 900px) {
      //   display: flex;
      // }

      span {
        width: 20px;
        height: 20px;
        border: solid;
        border-color: #fff;
      }

      .open-btn {
        border-width: 2px 2px 0 0;
        transform: translateX(-5px) rotate(45deg);
      }

      .close-btn {
        border-width: 0 0 2px 2px;
        transform: translateX(5px) rotate(45deg);
      }
    }

    .upper-wrapper {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      // margin-top: 2rem;
      .factory-name {
        background-color: #3a3a3a;
        width: 200px;
        display: flex;
        align-items: center;
        padding: 15px 20px;
        border-radius: 10px;
        margin-bottom: 1rem;
        img {
          width: 30px;
          height: 30px;
        }
        p {
          margin-left: .5rem;
          color: #fff;
          font-weight: bold;
        }
      }

      .title-text {
        font-size: 14px;
        margin-bottom: 1rem;
      }

      .total-price {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 1rem;
      }
    }


    .detail {
      margin-top: 24px;
      font-size: 12px;

      .toggle {
        display: block;
        width: 100%;
        // border-bottom: 2px solid #00A9B5;
        border-bottom: 2px solid #1bffc6;
        padding-bottom: 6px;
      }

      ul {
        li {
          margin-top: .5rem;
        }
      }
      margin-bottom: 48px;
    }

    .button-group {
        display: flex;
        // margin-right: 3rem;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .button {
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;

          // color: white;
          // background: #00939D;
          color: #fff;
          background: #1bffc6;
          border-radius: 99em;
          width: 200px;
          height: 45px;

          padding: 0px 15px;

          font-style: normal;
          font-weight: bold;
          font-size: 14px;
          line-height: 1;

          overflow: hidden;

          img, span {
            display: inline-block;
            z-index: 2;
          }

          img {
            margin-right: 10px;
          }

        }

        .green-button {
          position: relative;
          color: #000;
          margin-bottom: 1rem;
          &::before {
            content: '';
            position: absolute;
            background-color: #1be0a8;
            top: 0;
            left: auto;
            right: 0;
            width: 0;
            height: 100%;
            transition-duration: .5s;
            transition-timing-function: cubic-bezier(.075,.82,.165,1);
            z-index: 1;
          }

          &:hover{
            &::before {
              width: 100%;
              left: 0;
              right: auto;
            }
          }
        }

        .login-button {
          margin-top: 2rem;
        }

        .border-button {
          background: none;
          border: #fff 1px solid;
          margin-bottom: 1rem;
          transition: background .3s;

          &:hover {
            background: #4a4a4a;
          }
        }

        .gray-button {
          background: #3a3a3a;
          margin-bottom: 1rem;
          transition: background .3s;

          &:hover {
            background: #4a4a4a;
          }
        }
      }
  }

  .hidden-menu {
    transform: translateX(-300px) translateY(-50%);
  }

  .show {
    display: block;
  }

  .hidden {
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/LeftMenuCard.vue